import Driver from 'driver.js'

export const initDriver = () => {
  console.log('initDriver', Driver)
  const driver = new Driver()

  driver.defineSteps([
    {
      element: '#step-1',
      popover: {
        title: '品牌一键看懂',
        description: `
          <div class="text-sm text-[#1D2129]">
            <p>快速分析品牌表现，自动生成结构化报告与企业知识库。</p>
          </div>
        `,
        position: 'bottom',
      },
    },
    {
      element: '#step2',
      popover: {
        title: '品牌分析升级',
        description: `
          <div class="text-sm text-[#1D2129]">
            <p>输入“品牌词”或“官网链接”，AI 自动完成搜索与信息聚合，生成品牌分析报告。</p>
          </div>
        `,
        position: 'bottom',
      },
    },
    {
      element: '#step3',
      popover: {
        title: '企业信息自动建档',
        description: `
          <div class="text-sm text-[#1D2129]">
            <p>基于客户网址、基础资料，自动整理 GEO 企业信息卡。</p>
          </div>
        `,
        position: 'bottom',
      },
    },
    {
      element: '#step4',
      popover: {
        title: '企业知识库重构',
        description: `
          <div class="text-sm text-[#1D2129]">
            <p>把分散在文档、表格、聊天里的“企业知识”集中到一个知识库里管理。</p>
          </div>
        `,
        position: 'bottom',
      },
    },
  ])
  driver.start()
}
